//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { directive } from 'vue-awesome-swiper'

export default {
  name: 'MathsComment',
  components: {},
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
        },
      },
      isTablet: null,
    }
  },
  mounted() {
    this.windowSizeHandler()
    window.addEventListener('resize', this.windowSizeHandler, { passive: true })
  },
  methods: {
    windowSizeHandler() {
      this.isTablet = window.innerWidth <= 960
    },
  },
}
